import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRemove = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 10376",
		children: [/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse 422",
			cx: 10,
			cy: 10,
			r: 10,
			fill: "#FE5D7C"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Union",
			d: "M13.7641 6.23605C13.4492 5.92132 12.9388 5.92132 12.624 6.23605L9.98089 8.87903L7.37628 6.27432C7.06144 5.95958 6.55108 5.95958 6.23613 6.27432C5.92129 6.58926 5.92129 7.09963 6.23613 7.41447L8.84074 10.0191L6.2744 12.5854C5.95956 12.9004 5.95956 13.4107 6.2744 13.7256C6.43187 13.8829 6.63815 13.9616 6.84453 13.9616C7.0508 13.9616 7.25718 13.8829 7.41466 13.7256L9.98089 11.1593L12.5855 13.764C12.743 13.9213 12.9492 14 13.1556 14C13.3619 14 13.5683 13.9213 13.7258 13.764C14.0406 13.449 14.0406 12.9386 13.7258 12.6238L11.1212 10.0192L13.7641 7.3762C14.079 7.06126 14.079 6.55089 13.7641 6.23605Z",
			fill: "white"
		})]
	})
});
export default SvgRemove;
